import React, { useState, useEffect } from 'react';
import useLearningAssignmentToolStore from '@/stores/AdminStore/LearningAssignmentToolStore';
import CreateAssignment from './components/CreateAssignment';
import AssignmentHistory from './components/AssignmentHistory';
import './LearningAssignmentTool.css';

const LearningAssignmentTool: React.FC = () => {
  const {
    users,
    learningItems,
    assignments,
    userProgress,
    fetchUsers,
    fetchLearningItems,
    fetchAssignments,
    fetchUserProgress,
  } = useLearningAssignmentToolStore();

  const [activeTab, setActiveTab] = useState<'create' | 'history' | 'dynamic'>('create');

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'create' && !users) {
      fetchUsers();
    }
    if (activeTab === 'create' && !learningItems) {
      fetchLearningItems();
    }
  }, [activeTab, users, learningItems, fetchUsers, fetchLearningItems]);

  useEffect(() => {
    if (activeTab === 'history' && !assignments) {
      fetchAssignments();
    }
    if (activeTab === 'history' && !userProgress) {
      fetchUserProgress();
    }
  }, [activeTab, assignments, userProgress, fetchAssignments, fetchUserProgress]);

  return (
    <div className="lat-container">
      <div className="lat-breadcrumb">
        <span className="lat-breadcrumb-item">User Management</span>
        <span className="lat-breadcrumb-separator">›</span>
        <span className="lat-breadcrumb-item lat-breadcrumb-active">Learning Assignment Tool</span>
      </div>

      <div className="lat-header">
        <h1 className="lat-title">Learning Assignment Tool</h1>
        <p className="lat-subtitle">Bulk-assign learning items to selected users efficiently</p>
      </div>

      <div className="lat-tabs">
        <button
          className={`lat-tab ${activeTab === 'create' ? 'lat-tab-active' : ''}`}
          onClick={() => setActiveTab('create')}
        >
          Create Assignment
        </button>
        <button
          className={`lat-tab ${activeTab === 'history' ? 'lat-tab-active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          Assignment History
        </button>
        <button
          className={`lat-tab ${activeTab === 'dynamic' ? 'lat-tab-active' : ''}`}
          onClick={() => setActiveTab('dynamic')}
        >
          Dynamic Assignments
        </button>
      </div>

      <div className="lat-content">
        {activeTab === 'create' && <CreateAssignment />}
        {activeTab === 'history' && <AssignmentHistory />}
        {activeTab === 'dynamic' && (
          <div className="lat-placeholder">
            <p>Dynamic Assignments content coming soon...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LearningAssignmentTool;
